import "./News.module.css";
import Header from "@/reusable_sections/Header";
import BeritaTerbaru from "./sections/BeritaTerbaru";
import InformasiKontak from "@/reusable_sections/Footer";
import Footer from "./sections/Footer";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
import Breakingnewsticker from "./sections/Breakingnewsticker";
export default function NewsPage() {
  return <div>
      <Header />
      <Breakingnewsticker />
      <BeritaTerbaru />
      <GlossyBottomNavigation />
      <Footer />
      <InformasiKontak />
    </div>;
}